import { ValidatorFn, Validators } from '@angular/forms';

const PATTERN = /^[A-Za-zÀ-ÖØ-öø-ÿ0-9 .,:_\-+/&()?!#@'’"]+$/;

export const entityName: ValidatorFn = (control) =>
  Validators.pattern(PATTERN)(control)
    ? { entityName: control.value }
    : null;
